<div class="row panel-auth alinhar-center">
  <div class="col-md-7 col-lg-5 col-xl-5 col-sm-10 col-12 mx-auto align-self-center px-1 px-sm-2">
    <lds-auth></lds-auth>
  </div>
</div>
